import React from 'react';
import PropTypes from 'prop-types';

import apiFetch from 'modules/api-fetch';
import Toast from 'modules/toast';

export default class MessagesClientPush extends React.Component {
  static propTypes = {
    clientData: PropTypes.object.isRequired,
  };

  sendPush = async () => {
    // Trigger a dialog to get the input
    const messageText = prompt(
      'What would you like the push notification to say?',
    );
    if (messageText) {
      const config = {
        url: 'Trainer/SendPushNotification',
        method: 'GET',
        query: {
          clientId: this.props.clientData.data[0].id,
          message: messageText,
        },
      };
      try {
        await apiFetch(config);
        Toast.success('Push notification sent!');
      } catch (er) {
        Toast.error(`Error sending push: ${er}`);
      }
    }
  };

  render() {
    return (
      <button
        onClick={this.sendPush}
        type="button"
        className="btn btn-sm btn-outline-primary ml-2"
        title="Send client a push notification only"
      >
        Send Push
      </button>
    );
  }
}
